import { frontendURL } from 'dashboard/helper/URLHelper';

import SettingsWrapper from 'dashboard/routes/dashboard/settings/SettingsWrapper.vue';
import PipelinesHome from './Index.vue';
import PipelineEdit from './PipelineEdit.vue';

// Settings › CRM › Funis. The forms tab lives next door (forms.routes.js), under the same
// `settings/crm` path; CrmTabs links the two.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/crm/pipelines'),
      component: SettingsWrapper,
      // Not kept alive: the edit page loads its record on mount, so a cached instance would
      // show the first record opened when another one is picked.
      props: { keepAlive: false },
      children: [
        {
          path: '',
          name: 'pipelines_settings_index',
          meta: { permissions: ['administrator'] },
          component: PipelinesHome,
        },
        {
          path: ':pipelineId',
          name: 'pipelines_settings_edit',
          meta: { permissions: ['administrator'] },
          component: PipelineEdit,
        },
      ],
    },
  ],
};
